import React from "react";

import Page from "../../../_components/Layout/Page";
import Button from "../../../_components/Button";
import FilterProducts from "./components/Filter";

export default () => {
  function onClick(product) {
    window.location.href = `/product/${product.id}`;
  }

  const onGoToCreate = () =>{
    window.location.href = '/products/create'
  }

  return (
    <Page title="Produtos">
      <div className="my-3">
        <Button onClick={onGoToCreate}>Cadastrar novo produto <i className="fas fa-plus"></i></Button>
      </div>
      <FilterProducts onClick={onClick} />
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Products/index.jsx